export const getDocumentDirection = (): 'rtl' | 'ltr' => {
  const htmlDir = document.documentElement.dir.toLowerCase();
  const bodyDir = document.body.dir.toLowerCase();
  return (htmlDir || bodyDir || 'rtl') as 'rtl' | 'ltr';
};
